import Needs from "@/views/needs/Needs.vue";
import Need from "@/views/needs/Need.vue";

export default [
    {
        path: '/needs',
        component: Needs,
        meta: {
            access: ['enterprise'],
        }
    },
    {
        path: '/needs/:id',
        component: Need,
        meta: {
            access: ['enterprise']
        }
    },
]
